import { updateUserOffice } from "../../api/userOfficeService";

export const useUpdateUserOffice = (successCallback) => {
    const update = async (id, data) => {
        try {
            const updatedRecord = await updateUserOffice(id, data);
            successCallback(updatedRecord);
            return updatedRecord;
        } catch (error) {
            console.error("Failed to update user office:", error);
            throw error;
        }
    };

  return { update };
};